/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetLabelsResponseData,
  GetLabelsResponseDataFromJSON,
  GetLabelsResponseDataFromJSONTyped,
  GetLabelsResponseDataToJSON
} from './GetLabelsResponseData'

/**
 *
 * @export
 * @interface GetLabelsResponse
 */
export interface GetLabelsResponse {
  /**
   *
   * @type {number}
   * @memberof GetLabelsResponse
   */
  status?: number
  /**
   *
   * @type {GetLabelsResponseData}
   * @memberof GetLabelsResponse
   */
  data?: GetLabelsResponseData
}

export function GetLabelsResponseFromJSON(json: any): GetLabelsResponse {
  return GetLabelsResponseFromJSONTyped(json, false)
}

export function GetLabelsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLabelsResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetLabelsResponseDataFromJSON(json['data'])
  }
}

export function GetLabelsResponseToJSON(value?: GetLabelsResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetLabelsResponseDataToJSON(value.data)
  }
}
